import { useTournamentList } from 'state/tournament/hooks'
import styled from 'styled-components'
import { colors } from 'theme/colors'
import Text from 'UIKit/Text'
import { RowCenter } from '../Row'

const TournamentNoticeBadge = () => {
  const { availableTournaments } = useTournamentList()

  const activeTournaments = availableTournaments?.filter((tournament) => tournament.expiredTime > Date.now())
  const numberOfActiveTournaments = activeTournaments?.length

  return (
    !!numberOfActiveTournaments && (
      <StyledTournamentNotice
        width="18px"
        height="18px"
        position="absolute"
        borderRadius="50%"
        border="1px solid #232C3D"
        background={colors.strokeAlt3}
      >
        <Text fontSize="10px" fontWeight={700} letterSpacing="-0.2">
          {activeTournaments?.length}
        </Text>
      </StyledTournamentNotice>
    )
  )
}

const StyledTournamentNotice = styled(RowCenter)`
  bottom: 100%;
  transform: translate(50%, 50%);
  right: 100%;
  bottom: 100%;
`

export default TournamentNoticeBadge
